import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './StoreValue';
import { markStepComplete } from './StepGuard';
import { getAgentConfig } from '../utils/agentConfig';

const ESignatureInfo = () => {
    const { ContactGuid,agentIdVal,leadGuid, updateAgentId, updateContactGuid, updateLeadGuid } = useAuth();
    const [loading, setLoading] = useState(false);  // Add loading state
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [signature, setSignature] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');
        if (!leadGuid) {
            setErrorMessage('Session expired or lead data is missing. Please start over from the login page.');
            return;
        }
        setLoading(true);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const data = {
        leadguidVal: leadGuid,
        agentId: agentIdVal,
        Detail: {
            TranType: "TranType",
            TranAction: "TranAction",
            Ip: 'Ip'
        },
        Lead: {
            Guid: "string"
        }
    };

    try {
        // Step 1: eSignature Insert
        const response = await axios.post(`${API_BASE_URL}/api/Auth/LeadeSignature`, data);
        var responseCode = response.data.result.responseCode;
        var errorInfo = response.data.result?.debugInfo;

        if (responseCode !== '00') {
            setErrorMessage(errorInfo || 'eSignature submission failed.');
            setLoading(false);
            return;
        }

        // Step 2: Alert Query — skipped for agents configured with sendAlertEmail: false
        const agentConfig = getAgentConfig(agentIdVal);
        if (!agentConfig.sendAlertEmail) {
            markStepComplete('eSignature');
            navigate('/Completed');
            return;
        }

        const alertData = {
            leadguidVal: leadGuid,
            agentId: agentIdVal,
            Detail: {
                TranType: "Alert",
                TranAction: "Query",
                Ip: "Ip",
            },
            QueryRequest: {
                Detail: {
                    Client: agentIdVal,
                    Active: "1"
                },
                Alert: {
                    Description: "Completed Merchant Application"
                }
            },
        };

        const response1 = await axios.post(`${API_BASE_URL}/api/Auth/AlertQuery`, alertData);
        var res = response1.data;

        if (res === '00') {
            markStepComplete('eSignature');
            navigate('/Completed');
        } else {
            const alertMsg = typeof res === 'string' ? res : JSON.stringify(res);
            setErrorMessage(alertMsg || 'Alert Query failed.');
        }
    } catch (error) {
        console.error('Error submitting eSignature:', error);
        const serverMsg = error.response?.data?.message || error.response?.data || error.message;
        setErrorMessage(typeof serverMsg === 'string' ? serverMsg : 'An error occurred during submission.');
    } finally {
        setLoading(false);
    }
};

    return (
        <div className={`signature-container}`}>
          {loading && (
                <div className="loading-overlay">
                <div className="spinner-border" role="status">
                </div>
                </div>
        )}
        <Layout pageTitle="eSignature">
            <form onSubmit={handleSubmit}>
                <p>
                    Please click the button below to finalize your merchant application and receive a DocuSign request. Once signed, you will receive contact from our team to finish setting up your account for payment processing.
                </p>

                    <div className="d-flex justify-content-center mt-3">
    <button type="submit" className="btn btn-success px-5" style={{ width: '370px' }}>
    Send eSignature Document
    </button></div>

                </form>
                {/* Show loading image when waiting for response */}
                 {errorMessage && <p className="text-danger">{errorMessage}</p>}
                {successMessage && <p className="text-success">{successMessage}</p>}
            </Layout>
            </div>
    );
};

export default ESignatureInfo;
